import React, { ReactNode } from "react";

import "./threePartList.css";


interface ThreePartListProps {
    elements: ThreePartListElement[];
}

class ThreePartListElement {
    icon: ReactNode;
    title: string;
    value: string;

    constructor(icon: ReactNode, title: string, value: string) {
        this.icon = icon;
        this.title = title;
        this.value = value;
    }
}

export default function ThreePartList(props: ThreePartListProps) {
    return <ul className="three-part-list">
        {props.elements.map((element, index) => (
            <li key={index} className="three-part-list-item">
                {element.icon}
                <span className="three-part-list-title">{element.title}</span>
                <a className="three-part-list-value">{element.value}</a>
            </li>
        ))}
    </ul>;
}

export { ThreePartListElement };